import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/about/lxwm.jpg';
import _imports_1 from '@/assets/img/about/lxwm-750.jpg';
const _withScopeId = n => (_pushScopeId("data-v-ebe85f0a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "partner"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: ""
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "hidden-xs-only",
  src: _imports_0
}), /*#__PURE__*/_createTextVNode(), /*#__PURE__*/_createElementVNode("img", {
  class: "hidden-sm-and-up",
  src: _imports_1,
  alt: ""
})], -1));
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3);
}